@if (details$ | async; as details) {
  <div class="flex flex-col gap-6">
    <div class="rounded-sm border border-gray-200 p-4">
      <h5>Szczegóły użytkownika</h5>

      <p-divider appPrimengDivider />

      <div class="relative flex flex-col gap-1 bg-gray-50 p-6">
        <div class="grid gap-3 grid-cols-2">
          <div class="col-span-2">
            <app-details-view label="Identyfikator">
              {{ details.id }}
            </app-details-view>
          </div>

          <app-details-view label="Nazwa użytkownika">
            {{ details.username }}
          </app-details-view>

          <app-details-view label="Adres e-mail">
            {{ details.email }}
          </app-details-view>

          <app-details-view label="Imię i nazwisko">
            @if (isNotNil(details.firstName) && isNotNil(details.lastName)) {
              {{ details.firstName }} {{ details.lastName }}
            } @else {
              <app-no-data />
            }
          </app-details-view>

          <app-details-view label="Wyświetlana nazwa">
            @if (isNotNil(details.displayName)) {
              {{ details.displayName }}
            } @else {
              <app-no-data />
            }
          </app-details-view>

          <app-details-view label="Rodzaj">
            <app-account-type [type]="details.accountType" />
          </app-details-view>

          <app-details-view label="Status">
            <app-user-status [status]="details.status" />
          </app-details-view>

          <app-details-view label="Role">
            <div class="flex flex-wrap gap-3">
              @for (role of details.roles; track role) {
                <app-role [role]="role" />
              }
            </div>
          </app-details-view>

          <app-details-view label="Data utworzenia">
            <app-date-time [date]="details.createdAt" />
          </app-details-view>

          <app-details-view label="Data aktywacji">
            @if (isNotNil(details.activatedAt)) {
              <app-date-time [date]="details.activatedAt" />
            } @else {
              <app-no-data />
            }
          </app-details-view>

          <app-details-view label="Data ostatniego logowania">
            @if (isNotNil(details.lastLoginAt)) {
              <app-date-time [date]="details.lastLoginAt" />
            } @else {
              <app-no-data />
            }
          </app-details-view>

          <app-details-view label="Data ostatniej zmiany hasła">
            @if (isNotNil(details.lastPasswordChangeAt)) {
              <app-date-time [date]="details.lastPasswordChangeAt" />
            } @else {
              <app-no-data />
            }
          </app-details-view>
        </div>
      </div>
    </div>
  </div>
} @else {
  <app-spinner-filled />
}
